import { flatToNestedObject } from 'app/components/risk-matrix/flat-to-nested-object';
import { FavouriteLayoutAttributes } from '../../types';

export class LayoutConfig {
  public layoutAttributes: any;

  constructor(layoutAttributes: FavouriteLayoutAttributes) {
    this.layoutAttributes =  flatToNestedObject(layoutAttributes);
  }

  public text(name: string, ifMissing?: string): string {
    if (this.layoutAttributes.Text && this.layoutAttributes.Text.hasOwnProperty(name)) {
      return this.layoutAttributes.Text[name];
    }
    return ifMissing;
  }

  public showRowCount(): boolean {
    return !this.layoutAttributes.RowCount || !this.layoutAttributes.RowCount.HideRowCount;
  }

  public showFilter(): boolean {
    return !this.layoutAttributes.Filter || !this.layoutAttributes.Filter.HideFilter;
  }

  public drillDownSetting(name: string): any {
    if (this.layoutAttributes.drillDown && this.layoutAttributes.drillDown.hasOwnProperty(name)) {
      return this.layoutAttributes.drillDown[name];
    }
    return undefined;
  }

  public drillDownSettingBool(name: string, defaultValue: boolean): boolean {
    const val = this.drillDownSetting(name);
    return (val === undefined)
      ? defaultValue
      : val as boolean;
  }
}

export class ChartLayoutConfig extends LayoutConfig {
  public chartType(): string {
    return this.layoutAttributes.Highcharts && this.layoutAttributes.Highcharts.chart && this.layoutAttributes.Highcharts.chart.type
      ? this.layoutAttributes.Highcharts.chart.type
      : 'line';
  }

  public chartStyle(name: string) {
    if (this.layoutAttributes.HighchartsStyle && this.layoutAttributes.HighchartsStyle[name]) {
      return this.layoutAttributes.HighchartsStyle[name];
    }
    return undefined;
  }
}
